"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LottieType = exports.Lottie = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLottie = _interopRequireDefault(require("react-lottie"));
var _lodash = require("lodash");
var _lottieMonumentLoading = _interopRequireDefault(require("../../images/lottieMonumentLoading.json"));
var _registerCheckmark = _interopRequireDefault(require("../../images/registerCheckmark.json"));
var _registerCheckmarkGreen = _interopRequireDefault(require("../../images/registerCheckmarkGreen.json"));
var _searchingDocuments = _interopRequireDefault(require("../../images/searchingDocuments.json"));
var _AnimationData;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LottieType = /*#__PURE__*/function (LottieType) {
  LottieType["MonumentLoading"] = "monument-loading";
  LottieType["RegisterCheckmark"] = "register-checkmark";
  LottieType["RegisterCheckmarkGreen"] = "register-checkmark-green";
  LottieType["SearchingDocuments"] = "searching-documents";
  return LottieType;
}({});
exports.LottieType = LottieType;
var AnimationData = (_AnimationData = {}, _defineProperty(_AnimationData, LottieType.MonumentLoading, _lottieMonumentLoading.default), _defineProperty(_AnimationData, LottieType.RegisterCheckmark, _registerCheckmark.default), _defineProperty(_AnimationData, LottieType.RegisterCheckmarkGreen, _registerCheckmarkGreen.default), _defineProperty(_AnimationData, LottieType.SearchingDocuments, _searchingDocuments.default), _AnimationData);
var defaultOptions = {
  loop: false,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid'
  }
};
var Lottie = function Lottie(_ref) {
  var type = _ref.type,
    options = _ref.options,
    width = _ref.width,
    height = _ref.height;
  var animationOptions = (0, _lodash.defaultsDeep)(_objectSpread(_objectSpread({}, options), {}, {
    animationData: AnimationData[type]
  }), defaultOptions);
  return /*#__PURE__*/_react.default.createElement(_reactLottie.default, {
    options: animationOptions,
    width: width,
    height: height
  });
};
exports.Lottie = Lottie;